export default __webpack_public_path__ + "static/media/outline-white.1d9ab89e.png";